export default {
  name: "Français",
  pageTitles: {
    home: "Académie AETHERIS — La Clarté au service de votre Souveraineté",
    kit: "Kit Digital Premium — Académie AETHERIS",
    about: "À Propos — Académie AETHERIS",
    services: "La Méthode — Académie AETHERIS",
    bilan: "Bilan Souveraineté Offert — Académie AETHERIS",
    merci: "Merci — Académie AETHERIS",
  },
  pageDescs: {
    home: "Académie AETHERIS — Révélez l'architecture secrète de votre vie. Méthode Triple Fusion™ : Numérologie, Feng Shui et IFÀ pour dirigeants et entrepreneurs.",
    kit: "Kit Digital Premium — 67€ : le livre « Avant que tu ne deviennes », les 12 Décrets Souverains, le Cahier Souverain et les grilles Triple Fusion™. Livraison immédiate.",
    about: "Rodrigue CASSILDÉ, Architecte de Vie et fondateur de l'Académie AETHERIS. La méthode Triple Fusion™ née de 20 ans de recherche et de terrain.",
    services: "Découvrez les offres de l'Académie AETHERIS : Diagnostic gratuit, Kit Digital 67€, Analyses personnalisées et Coaching élite Triple Fusion™.",
    bilan: "Réservez votre Diagnostic de Souveraineté OFFERT avec l'Académie AETHERIS. Identifiez ce qui bloque votre trajectoire en 24h.",
    merci: "Merci pour votre commande — téléchargez vos 6 outils Triple Fusion™.",
  },
  nav: { home: "Accueil", method: "La Méthode", kit: "Kit Digital", about: "À Propos", bilan: "Bilan Offert" },
  hero: {
    eyebrow: "Académie AETHERIS — Architecture de Vie",
    titleLines: ["La Clarté au service", "de votre Souveraineté."],
    sub: "Ne subissez plus votre destin. Accédez à la justesse millénaire de la fusion IFÀ, Lo Shu et Pythagore pour lever vos blocages et bâtir votre propre empire.",
    ctaPrimary: "Demander votre Bilan Souveraineté offert",
    ctaSecondary: "Découvrir la Méthode",
  },
  marquee: ["Triple Fusion™", "Numérologie Vibratoire", "Feng Shui Tibétain", "Architecture de Vie", "Grille Lo Shu", "Souveraineté Totale", "Dettes Karmiques"],
  method: {
    label: "La Méthode Triple Fusion™",
    title: "Trois sagesses millénaires, une trajectoire de pouvoir.",
    quote: "PYTHAGORE a décodé les nombres. Lo Shu a décodé l'espace. IFÀ — Patrimoine Immatériel de l'UNESCO — a décodé le destin. La Triple Fusion™ est la première méthode à unir ces trois sagesses.",
    cards: [
      { num: "01", name: "IFÀ", tag: "Mémoire", title: "La mémoire de votre lignée", desc: "Sagesse ancestrale classée au Patrimoine Immatériel de l'UNESCO. IFÀ révèle les dettes de lignage et les schémas hérités qui se répètent dans votre vie — pour enfin les désamorcer." },
      { num: "02", name: "Lo Shu", tag: "Espace", title: "L'harmonie de votre environnement", desc: "La grille Lo Shu, cœur du Feng Shui tibétain, cartographie votre espace de vie pour que chaque direction travaille pour vous, jamais contre vous." },
      { num: "03", name: "Pythagore", tag: "Nombre", title: "La vibration de votre identité", desc: "Votre nom et votre date de naissance forment une signature vibratoire unique. Pythagore la décode pour des décisions souveraines, prises au bon moment." },
    ],
  },
  pathways: {
    label: "Les Voies",
    title: "Choisissez le degré de votre métamorphose.",
    offers: [
      { id: "diagnostic", name: "Bilan Souveraineté", price: "Offert", features: ["Lecture de votre matrice natale", "Identification de vos verrous prioritaires", "Appel de restitution de 30 minutes"], cta: "Réserver mon bilan", to: "bilan" },
      { id: "analyse", name: "Analyse Précision", price: "149€", features: ["Grille Lo Shu personnelle complète", "Rapport vibratoire détaillé", "Recommandations Feng Shui ciblées"], cta: "Commander l'analyse", to: "bilan" },
      { id: "pack", name: "Pack Renaissance Quantique", price: "250€", badge: "Le plus choisi", features: ["Inclut l'Analyse Précision complète", "Libération des dettes karmiques", "Protocole de reconquête 90 jours"], cta: "Choisir la Renaissance", to: "bilan" },
      { id: "elite", name: "Coaching Élite — Métamorphose", price: "1 950€", features: ["Suivi individuel Triple Fusion™", "Architecture de Vie complète", "Accès au Cercle privé AETHERIS"], cta: "Candidater", to: "bilan" },
    ],
  },
  kitHome: {
    label: "Kit Digital Premium",
    title: "Le livre qu'on aurait dû vous remettre à la naissance.",
    desc: "Un décodeur d'identité : vos schémas répétitifs, les verrous de votre lignée, vos cycles numériques — et les clés concrètes pour les désactiver, un par un.",
    price: "67€",
    cta: "Découvrir le Kit",
  },
  founder: {
    label: "Le Fondateur",
    name: "Rodrigue Cassildé",
    bio: "Autorité en Architecture de Vie, Numérologie Vibratoire et Feng Shui Triple Fusion™. Depuis 15 ans, il guide dirigeants, entrepreneurs et bâtisseurs d'empires vers la Souveraineté Totale.",
    cta: "Découvrir son parcours",
  },
  finalCta: { title: "Votre empire commence par un diagnostic.", cta: "Demander votre Bilan Souveraineté offert" },
  kit: {
    badges: ["Livraison immédiate", "Paiement sécurisé — Stripe", "Accès à vie"],
    label: "Kit Digital Premium",
    title: "Les 6 outils fondateurs de votre reconquête.",
    sub: "Un système complet — livre, décrets, cahier, grilles et lettre — pour décoder qui vous êtes et reprendre la main.",
    toolsLabel: "Le Contenu",
    toolsTitle: "6 outils souverains, conçus pour être utilisés.",
    tools: [
      { name: "AVANT QUE TU NE DEVIENNES", tag: "Le livre fondateur" },
      { name: "Les 12 Décrets Souverains", tag: "Lois d'alignement" },
      { name: "Le Cahier Souverain", tag: "Journal opérationnel — 90 jours" },
      { name: "La Grille Guidée Triple Fusion™", tag: "Cartographie personnelle" },
      { name: "La Carte des Directions Lo Shu", tag: "Boussole de l'espace" },
      { name: "La Lettre du Fondateur", tag: "Message personnel de Rodrigue Cassildé" },
    ],
    bookLabel: "Le Livre Fondateur",
    bookTitle: "Avant que tu ne deviennes — le livre que tu aurais dû recevoir à la naissance.",
    bookCopy: [
      "Personne ne t'a remis le mode d'emploi. Pas l'école, pas ta famille, pas la société. Tu as appris à fonctionner — jamais à te décoder.",
      "Ce livre est un décodeur d'identité. Il croise la sagesse d'IFÀ, la grille Lo Shu et les nombres de Pythagore pour te révéler ce qui a toujours été écrit : tes cycles, tes verrous, tes lignes de force.",
    ],
    bullets: [
      "Tes schémas répétitifs — et pourquoi ils reviennent toujours",
      "Les verrous de ta lignée — et comment les désactiver",
      "Tes cycles numériques personnels — pour décider au bon moment",
      "Ta cartographie Triple Fusion™ — ton point de départ souverain",
    ],
    ctaTitle: "Votre reconquête commence maintenant.",
    ctaSub: "Un investissement unique de 67€ pour recevoir les 6 outils fondateurs de la méthode Triple Fusion™.",
    buy: "Je commande mon Kit — 67€",
    note: "Livraison par email immédiatement après le paiement.",
    afterLink: "Déjà commandé ? Accédez à vos téléchargements",
  },
  about: {
    label: "À Propos",
    title: "L'architecte derrière la méthode.",
    bioLabel: "Le Fondateur",
    bio: [
      "Rodrigue Cassildé — autorité en Architecture de Vie, Numérologie Vibratoire et Feng Shui Triple Fusion™.",
      "Depuis 15 ans, il guide dirigeants, entrepreneurs et bâtisseurs d'empires vers la Souveraineté Totale. Sa conviction : personne ne devrait subir un destin qu'il n'a pas décodé.",
      "L'Académie AETHERIS est née de cette conviction — une maison où trois sagesses millénaires deviennent une seule trajectoire de pouvoir.",
    ],
    quote: "PYTHAGORE a décodé les nombres. Lo Shu a décodé l'espace. IFÀ — Patrimoine Immatériel de l'UNESCO — a décodé le destin. La Triple Fusion™ est la première méthode à unir ces trois sagesses.",
    valuesLabel: "Valeurs Cardinales",
    valuesTitle: "Ce qui ne se négocie jamais.",
    values: [
      { num: "01", name: "Excellence", desc: "Aucun compromis. Chaque analyse, chaque protocole, chaque mot est délivré avec la même exigence — votre trajectoire mérite le meilleur des trois sagesses." },
      { num: "02", name: "Souveraineté", desc: "Maître de votre destin. Nous ne créons pas de dépendance : nous transmettons les clés pour que vous ne subissiez plus jamais." },
      { num: "03", name: "Discrétion", desc: "Élite, confidentiel. Votre matrice, vos verrous, vos décisions — tout ce qui se dit ici reste ici." },
    ],
    legalLabel: "Structure Légale",
    legal: "L'Académie AETHERIS opère sous Synergie VITA Holding (SVH), SAS au capital de 500€, immatriculée au RCS Fort-de-France sous le SIREN 108849241.",
    ctaTitle: "Prêt à rencontrer votre matrice ?",
    cta: "Demander votre Bilan Souveraineté offert",
  },
  services: {
    label: "Nos Services",
    title: "Une voie pour chaque degré de Souveraineté.",
    sub: "Du premier diagnostic au mentorat d'élite, chaque voie est une marche. Choisissez la vôtre.",
    offers: [
      { id: "diagnostic", name: "Bilan Souveraineté", price: "Offert", desc: "Le point de départ. 30 minutes pour lire votre matrice et nommer ce qui bloque.", features: ["Lecture de votre matrice natale", "Identification de vos verrous prioritaires", "Appel de restitution de 30 minutes"], cta: "Réserver mon bilan", to: "bilan" },
      { id: "kit", name: "Kit Digital Premium", price: "67€", desc: "Les 6 outils fondateurs de la méthode Triple Fusion™, livrés immédiatement.", features: ["Le livre « Avant que tu ne deviennes »", "Les 12 Décrets Souverains", "Le Cahier Souverain — 90 jours", "La Grille Guidée Triple Fusion™"], cta: "Commander le Kit", to: "kit" },
      { id: "analyse", name: "Analyse Précision", price: "149€", desc: "Votre cartographie vibratoire complète.", features: ["Grille Lo Shu personnelle complète", "Rapport vibratoire détaillé", "Recommandations Feng Shui ciblées"], cta: "Commander l'analyse", to: "bilan" },
      { id: "pack", name: "Pack Renaissance Quantique", price: "250€", badge: "Le plus choisi", desc: "L'analyse, la libération, le protocole.", features: ["Inclut l'Analyse Précision complète", "Libération des dettes karmiques", "Protocole de reconquête 90 jours"], cta: "Choisir la Renaissance", to: "bilan" },
      { id: "elite", name: "Coaching Élite — Métamorphose", price: "1 950€", desc: "Trois mois de mentorat privé avec Rodrigue Cassildé.", features: ["Suivi individuel Triple Fusion™", "Architecture de Vie complète", "Accès au Cercle privé AETHERIS"], cta: "Candidater", to: "bilan" },
    ],
  },
  bilan: {
    label: "Bilan Souveraineté Offert — 30 minutes",
    title: "Vous sentez que quelque chose bloque votre vie — sans savoir quoi ?",
    sub: "En 30 minutes, nous lisons votre matrice, identifions vos verrous prioritaires et vous remettons un plan d'action concret. Sans engagement.",
    benefitsLabel: "Vous repartez avec",
    benefits: [
      "Une lecture claire de votre matrice natale",
      "L'identification de vos verrous prioritaires",
      "Vos premières directions Lo Shu",
      "Un plan d'action concret et immédiat",
    ],
    testimonialsLabel: "Ils ont franchi le pas",
    testimonials: [
      { text: "En un seul appel, Rodrigue a nommé ce que trois années de thérapie n'avaient fait qu'effleurer. Mon protocole 90 jours a tout changé.", name: "Claire M.", role: "Cheffe d'entreprise" },
      { text: "L'Analyse Précision m'a lue comme un livre ouvert. J'ai enfin compris pourquoi les mêmes schémas revenaient — et comment y mettre fin.", name: "Julien R.", role: "Dirigeant" },
      { text: "J'étais sceptique. Puis la grille Lo Shu a expliqué ma maison, mes choix, mes blocages. Plus rien n'a été pareil depuis.", name: "Sofia D.", role: "Fondatrice" },
    ],
    form: {
      title: "Réservez votre créneau",
      firstNames: "Prénoms",
      lastName: "Nom",
      maidenName: "Nom de jeune fille (optionnel)",
      birthDate: "Date de naissance",
      sex: "Sexe",
      female: "Femme",
      male: "Homme",
      email: "Email",
      submit: "Demander mon Bilan Offert",
      sending: "Envoi en cours…",
      success: "Votre demande est bien reçue. Rodrigue vous contactera sous 24h. En attendant, vous pouvez aussi réserver directement un créneau :",
      calendlyButton: "Réserver mon appel de suivi (30 min)",
      error: "Une erreur est survenue. Réessayez dans un instant.",
    },
    quote: { text: "Vous n'êtes pas bloqué. Vous fonctionnez simplement avec le mauvais mode d'emploi.", author: "Rodrigue Cassildé" },
  },
  merci: {
    label: "Commande Confirmée",
    title: "Votre Kit est en route.",
    sub: "Vos 6 outils vous parviennent par email. Vous pouvez également les télécharger immédiatement ci-dessous.",
    frOnlyNote: "Vos outils en français vous sont livrés par email immédiatement après votre paiement.",
    downloadsLabel: "Vos téléchargements",
    note: "Conservez ces liens précieusement — accès à vie.",
    backHome: "Retour à l'accueil",
  },
  footer: {
    tagline: "Architecture de Vie — IFÀ ◆ Lo Shu ◆ Pythagore",
    navTitle: "Navigation",
    langTitle: "Langue",
    svh: "Académie AETHERIS — Synergie VITA Holding (SVH), SAS au capital de 500€ — RCS Fort-de-France — SIREN 108849241",
    rights: "© 2026 Académie AETHERIS. Tous droits réservés.",
  },
};
